import BaseComponent from "components/base-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default class ComponentsScoreFactorsLink extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    scoreFactor: instanceOfClassName("ScoreFactor").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, scoreFactor, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--score-factors--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || scoreFactor.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || scoreFactor.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, scoreFactor} = this.p

    if (adminLayout) return Routes.adminScoreFactorPath(scoreFactor.id())
  }
}
